import * as React from 'react';
import { useEffect, useLayoutEffect } from 'react';

const useReactId = React["useId".toString()] || (() => void 0);
let count = 0;
function useId(props) {
  const { deterministicId } = {};
  const [id, setId] = React.useState(useReactId());
  useIsomorphicLayoutEffect(() => {
    if (!deterministicId) {
      setId((reactId) => reactId ?? String(count++));
    }
  }, [deterministicId]);
  return { id: (deterministicId || id) ?? "" };
}
function isServer() {
  return typeof window === "undefined" && typeof global !== "undefined";
}
const useIsomorphicLayoutEffect = isServer() ? useEffect : useLayoutEffect;

export { useId as default };
//# sourceMappingURL=useId.mjs.map
